import { IHouseOfferHistoryV4Schema } from '../../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';
import { IOffersHistoryListingData } from '../../../types/offerHistory';
import { EDealType } from '../../../types/dealType';
import { getOfferDateEnd, getOfferDeactivatedLabel } from '../../../utils/offerHistory';

export const prepareOffers = (
  offers: IHouseOfferHistoryV4Schema[],
  dealType: EDealType,
): IOffersHistoryListingData['offers'] => {
  return offers.map(offer => ({
    ...offer,
    deactivatedTitle: getOfferDeactivatedLabel(offer, dealType),
    dateEnd: getOfferDateEnd(offer, dealType),
    expositionFull: `${offer.exposition} на Циан`,
  }));
};
